(() => {
  const faqPages = document.querySelectorAll("[data-orsa-faq-page]");
  if (!faqPages.length) return;

  faqPages.forEach((page) => {
    const items = Array.from(page.querySelectorAll(".orsa-faq-page__item"));

    items.forEach((item) => {
      item.addEventListener("toggle", () => {
        const icon = item.querySelector(".orsa-faq-page__icon");
        if (!icon) return;

        icon.textContent = item.open ? "−" : "+";
      });
    });
  });
})();